// extracted by mini-css-extract-plugin
export default {"email":"UserItem_email__bufpS","groupsWrapper":"UserItem_groupsWrapper__lOZ7F","group":"UserItem_group__2OeAi"};